import { Injectable } from '@angular/core';
import { OdbiorcaDto, ZalacznikWiadomosciDto } from '@interfaces/komunikacja/komunikacja.interface';
import {
  LiczbaNieodebranychWiadomosciDto,
  UstawStatusWiadomosciJakoNieprzeczytanaRequest,
  UstawStatusWiadomosciOdebranejJakoPrzeczytanaRequest,
  UsunWiadomoscOdebranaRequest,
  WiadomoscOdebranaDto,
  WiadomoscOdebranaDtoQueryParams,
} from '@interfaces/komunikacja/wiadomosc-odebrana.interface';
import { PageQueryParams } from '@interfaces/params.interface';
import { IPaginatedData } from '@interfaces/response.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WiadomosciOdebraneService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/komunikacja/wiadomosci/wiadomosci-odebrane`;

  getRecord(id: string): Observable<WiadomoscOdebranaDto> {
    return this.http.get<WiadomoscOdebranaDto>(`${this.endpoint}/${id}`);
  }

  delete(body: UsunWiadomoscOdebranaRequest): Observable<null> {
    return this.http.delete<null>(`${this.endpoint}`, { body });
  }

  getRecords(queryParams?: WiadomoscOdebranaDtoQueryParams): Observable<IPaginatedData<WiadomoscOdebranaDto>> {
    return this.http.get<IPaginatedData<WiadomoscOdebranaDto>>(this.endpoint, {
      params: this.createQueryParams(queryParams),
    });
  }

  getRecipient(id: string): Observable<IPaginatedData<OdbiorcaDto>> {
    return this.http.get<IPaginatedData<OdbiorcaDto>>(`${this.endpoint}/${id}/odbiorcy`);
  }

  getAttachments(id: string, params?: PageQueryParams): Observable<IPaginatedData<ZalacznikWiadomosciDto>> {
    return this.http.get<IPaginatedData<ZalacznikWiadomosciDto>>(`${this.endpoint}/${id}/zalaczniki`, {
      params: this.createQueryParams(params),
    });
  }

  getAttachment(id: string, attachmentId: string): Observable<ArrayBuffer> {
    return this.http.get<ArrayBuffer>(`${this.endpoint}/${id}/zalaczniki/${attachmentId}`, {
      responseType: 'arraybuffer' as 'json',
    });
  }

  getNumberOfUnreadMessages(): Observable<LiczbaNieodebranychWiadomosciDto> {
    return this.http.get<LiczbaNieodebranychWiadomosciDto>(`${this.endpoint}/liczba-nieodebranych-wiadomosci`);
  }

  setMessageAsRead(data: UstawStatusWiadomosciOdebranejJakoPrzeczytanaRequest): Observable<null> {
    return this.http.patch<null>(`${this.endpoint}/oznacz-jako-przeczytana`, data);
  }

  setMessageAsUnread(data: UstawStatusWiadomosciJakoNieprzeczytanaRequest): Observable<null> {
    return this.http.patch<null>(`${this.endpoint}/oznacz-jako-nieprzeczytana`, data);
  }
}
